export default __webpack_public_path__ + "static/media/lucky-spin-banner-cn.443f55c6.webp";